<template>
    <icon-font :type="type"/>
</template>

<script>
    import { Icon } from 'ant-design-vue';

    const IconFont = Icon.createFromIconfontCN({
        scriptUrl: '//at.alicdn.com/t/font_1218192_60tdahin23l.js',
    });

    export default {
        name: "IconFontCn",
        props: {
            type: {
                type: String,
                required: true,
            }
        },
        components: {
            IconFont
        }
    }
</script>

<style scoped>

</style>